import type { IconComponentBaseProps } from 'components/atoms/Icon/types';

import { defaultTheme } from '@/theme';

type CloseProps = IconComponentBaseProps;

export const Close = ({
  className,
  width = 24,
  height = 24,
  fill = defaultTheme.mantineColors.gray[7],
}: CloseProps) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_7277_13000"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill={fill} />
      </mask>
      <g mask="url(#mask0_7277_13000)">
        <path
          d="M12 13.0537L6.92701 18.127C6.78851 18.2653 6.61443 18.3362 6.40476 18.3395C6.19526 18.3427 6.01801 18.2718 5.87301 18.127C5.72818 17.982 5.65576 17.8063 5.65576 17.6C5.65576 17.3937 5.72818 17.218 5.87301 17.073L10.9463 12L5.87301 6.927C5.73468 6.7885 5.66385 6.61441 5.66051 6.40475C5.65735 6.19525 5.72818 6.018 5.87301 5.873C6.01801 5.72816 6.19368 5.65575 6.40001 5.65575C6.60635 5.65575 6.78201 5.72816 6.92701 5.873L12 10.9462L17.073 5.873C17.2115 5.73466 17.3856 5.66383 17.5953 5.6605C17.8048 5.65733 17.982 5.72816 18.127 5.873C18.2718 6.018 18.3443 6.19366 18.3443 6.4C18.3443 6.60633 18.2718 6.782 18.127 6.927L13.0538 12L18.127 17.073C18.2653 17.2115 18.3362 17.3856 18.3395 17.5952C18.3427 17.8047 18.2718 17.982 18.127 18.127C17.982 18.2718 17.8063 18.3442 17.6 18.3442C17.3937 18.3442 17.218 18.2718 17.073 18.127L12 13.0537Z"
          fill={fill}
        />
      </g>
    </svg>
  );
};
